import React, { useEffect, useState } from 'react';
import { Button, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DemandeDPSStep3OnePartie from './demandeDpsStep3OneP';

const DemandeDPSStep3 = ({
    register,
    errors,
    setValue,
    watch,
    step2watch,
}) => {
    const [parties, setParties] = useState([]);
    const partieVide = {
        id: parties.length == 0 ? 1 : parties[parties.length -1].id + 1,
        dateDebutPartieEvenement: null,
        dateFinPartieEvenement: null,
        dateDebutPartieSecours: null,
        dateFinPartieSecours: null,
        effectifPublicP1: 0,
        effectifActeurs: 0,
        typePublicP2: null,
        activiteActeurs: null,
        venteAlcool: false,
        pyrotechnie: false,
        enginsMotrises: false,
        risquesPublic: null,
        risquesActeurs: null,
    };

    const ajouterPartie = () => {
        setParties((prevParties) => {
            const tempArray = [...prevParties];
            tempArray.push(partieVide);
            return tempArray;
        });
    }

    const updatePartieFromComponent = (partieUpdated) => {
        setParties((prevLignes) => {
            const tempArray = [...prevLignes];
            const index = tempArray.findIndex((tempBlog) => tempBlog.id == partieUpdated.id);
            tempArray[index] = partieUpdated;
            return tempArray;
        });
    }

    const removePartieFromComponent = (id) => {
        setParties(parties => [...parties.filter((partie) => partie.id != id)]);
    }

    useEffect(()=>{
        if(parties && parties != null && Array.isArray(parties) &&parties.length > 0){
            setValue("parties", parties)
        }
    },[parties])

    useEffect(()=>{
        if(watch("parties") && Array.isArray(watch("parties")))
        {
            setParties(watch("parties"))
        }else{
            ajouterPartie();
        }
    },[])

    return (<>
        {parties.map((partie, i)=>{return(
            <DemandeDPSStep3OnePartie
                key={i}
                register={register}
                errors={errors && errors.parties && errors.parties.length && errors.parties[i] ? errors.parties[i] : null}
                setValue={setValue}
                watch={watch}
                step2watch={step2watch}
                partieInitiale={partie}
                updatePartieFromComponent={updatePartieFromComponent}
                removePartieFromComponent={removePartieFromComponent}
            />
        )})}

        <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-success bg-success-subtle text-success-emphasis"} as={Button} onClick={ajouterPartie}>
            <center><b><FontAwesomeIcon icon='plus'/> Ajouter une autre plage horaire aux caractéristiques différentes</b></center>
        </div>

        {errors && errors.parties && errors.parties.length > 0 ?
            errors.parties.map((errPartie, i)=>{return(<center key={i}>
                {errPartie.effectifPublicP1 ? <small className="text-danger">Partie {i+1} : {errPartie.effectifPublicP1.message}<br/></small> : null}
                {errPartie.typePublicP2 ? <small className="text-danger">Partie {i+1} : {errPartie.typePublicP2.message}<br/></small> : null}
                {errPartie.effectifActeurs ? <small className="text-danger">Partie {i+1} : {errPartie.effectifActeurs.message}<br/></small> : null}
                {errPartie.activiteActeurs ? <small className="text-danger">Partie {i+1} : {errPartie.activiteActeurs.message}<br/></small> : null}
            </center>)})
        : null}
    </>);
};


DemandeDPSStep3.propTypes = {};

export default DemandeDPSStep3;